// src/components/common/ConfirmationModal.js
// Updated: 10/20/2025 09:00 AM (Accept and use zIndexClass prop)

import React from 'react';
import ModalWrapper from './ModalWrapper';

// Accept zIndexClass prop
const ConfirmationModal = ({ title, message, onConfirm, onCancel, confirmText = "Confirm", confirmColor = "red", zIndexClass }) => {
  const colorClasses = { red: 'bg-red-600 hover:bg-red-700 focus:ring-red-500', blue: 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500' };

  return (
    // Pass zIndexClass down to ModalWrapper
    <ModalWrapper onClose={onCancel} size="sm" zIndexClass={zIndexClass}>
      <div className="p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900">{title}</h3>
        <div className="mt-2"><p className="text-sm text-gray-500">{message}</p></div>
      </div>
      <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
        <button type="button" className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm ${colorClasses[confirmColor]}`} onClick={onConfirm}>{confirmText}</button>
        <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm" onClick={onCancel}>Cancel</button>
      </div>
    </ModalWrapper>
  );
};

export default ConfirmationModal;